module.exports = __webpack_public_path__ + "static/media/luminor.eccccecc.svg";